"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContractCall = void 0;
const contract_has_no_address_error_js_1 = require("./errors/contract-has-no-address.error.js");
function createContractCall(contract, fnName, args) {
    if (!contract.options.address) {
        throw new contract_has_no_address_error_js_1.ContractHasNoAddressError(fnName);
    }
    const abi = contract.options.jsonInterface;
    const abiItem = abi.find((abiItem) => {
        if (abiItem.type !== 'function') {
            return false;
        }
        if ('name' in abiItem) {
            return abiItem.name === fnName;
        }
        return false;
    });
    if (!abiItem) {
        throw new Error(`Web3Multicall.contractCall: Unexpected exception: Abi item not found`);
    }
    return {
        address: contract.options.address,
        abi: abiItem,
        args,
    };
}
exports.createContractCall = createContractCall;
